import { render, staticRenderFns } from "./shift-table.vue?vue&type=template&id=486f8eda&scoped=true&"
import script from "./shift-table.js?vue&type=script&lang=js&"
export * from "./shift-table.js?vue&type=script&lang=js&"
import style0 from "./shift-table.scss?vue&type=style&index=0&id=486f8eda&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "486f8eda",
  null
  
)

export default component.exports